import { Fragment, useState, useEffect } from "react";
import "../css/styles.css";
import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { formatWarehouse } from "../warehouseTime";
import { db, functions } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { v4 as uuidv4 } from "uuid";

const ReservationModal = ({
  parking,
  place,
  open,
  setOpen,
  setChange,
  change,
  cancelButtonRef,
  changeType,
  collection,
  documentId,
  section,
}) => {
  const [currentDate, setCurrentDate] = useState(formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss'));
  const [containerNumber, setContainerNumber] = useState();
  const [typeOfContainer, setTypeOfContainer] = useState("Amazon");

  useEffect(() => {
    setCurrentDate(formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss'))
  }, [open])

  useEffect(() => {
    setTypeOfContainer('Amazon');
    setContainerNumber()
  }, [changeType])

  const handleReservation = async () => {
    if (
      currentDate === undefined ||
      containerNumber === undefined ||
      typeOfContainer === undefined
    ) {
      openToast("Please complete all fields.");
    } else {
      // Use callable function to perform atomic reserve
      const uuid = uuidv4();
      const object = {
        type: typeOfContainer,
        place: place,
        parking: parking,
        date: currentDate,
        containerNumber: containerNumber,
        section: section === undefined ? "" : section,
        uid: uuid,
      };

      try {
        const reserveFn = httpsCallable(functions, "reserveParkingPlace");
        const result = await reserveFn({ collection, documentId, object });
        if (result.data && result.data.success) {
          setOpen(false);
          setChange(!change);
        }
      } catch (err) {
        const msg = err?.message || "Reservation failed";
        openToast(msg);
        return;
      }
    }
  };

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.error(message, {
        position: "top-center",
      });
    }
  };

  return (
    <>
      {" "}
      <ToastContainer
        style={{ width: "800px", zIndex: "10000" }}
        autoClose={2000}
      />
      <Transition.Root show={open}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center align-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  style={{
                    display: "flex",
                    flexFlow: "column nowrap",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "450px",
                  }}
                  className="relative width transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xs"
                >
                  <div
                    style={{ width: "100%", height: "83%" }}
                    className="bg-white"
                  >
                    <div
                      style={{ width: "100%" }}
                      className="sm:flex sm:flex-col sm:items-center"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexFlow: "column nowrap",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                        className="text-center mt-3"
                      >
                        <Dialog.Title
                          as="h3"
                          className="text-sm font-semibold leading-6 text-gray-900"
                        >
                          Place reservation
                        </Dialog.Title>
                        <div
                          style={{ paddingLeft: "20px", paddingRight: "20px" }}
                          className="container text-left"
                        >
                          <div>
                            <label
                              htmlFor="formGroupExampleInput"
                              className="form-label"
                            >
                              Arrival date
                            </label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              id="formGroupExampleInput"
                              placeholder=""
                              name="departureDate"
                              value={currentDate}
                              onChange={(e) => {
                                setCurrentDate(e.target.value);
                              }}
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="firstContainerNumber"
                              className="form-label"
                            >
                              Container number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="firstContainerNumber"
                              name="firstContainerNumber"
                              onChange={(e) =>
                                setContainerNumber(e.target.value)
                              }
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              htmlFor="formGroupExampleInput"
                              className="form-label"
                            >
                              Type of container
                            </label>
                            <select
                              className="form-control"
                              id="type2"
                              name="type"
                              type="text"
                              onChange={(e) =>
                                setTypeOfContainer(e.target.value)
                              }
                              required
                            >
                              <option selected>Amazon</option>
                              <option>Slam</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 w-full sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      style={{
                        borderWidth: "2px",
                        borderStyles: "solid",
                        borderColor: "black",
                        cursor: "pointer",
                      }}
                      className="amazon-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                      onClick={() => handleReservation()}
                      id="modal-button"
                    >
                      Reserve
                    </button>
                    <button
                      type="button"
                      style={{ cursor: "pointer" }}
                      className="amazon-button-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                      onClick={() => setOpen(false)}
                      id="modal-button"
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default ReservationModal;
